import createClient from "@tt/vue-components/src/services/apiClient";
import EnvProvider from "@tt/vue-environment/EnvProvider";
import baseApiService from "@tt/vue-components/src/services/baseApiService";
const apiClient = createClient(EnvProvider.value("EXPORT_API_URL"));

const ExportService = {
  exports: {
    ...baseApiService(apiClient, "exports"),
    regenerateReport: async (body) => {
      return await apiClient.post("export_time_frames:regenerate_report", body);
    },
  },
  exportTimeframes: {
    ...baseApiService(apiClient, "export_time_frames"),
  },
  timeframes: {
    ...baseApiService(apiClient, "time_frames"),
  },
};
export default ExportService;
